module.exports = __webpack_public_path__ + "static/efficience-fc4c7d2518147b6b975033b26736d5c3.png";